import { useAppLocationState } from '@react-admin/ra-navigation';
import { useEffect, useRef } from 'react';
import {
  NumberInputProps,
  useGetMany,
  useSimpleFormIteratorItem,
} from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { QuickbooksPriceInput } from '../../components/QuickbooksPriceInput';
import { Item } from '../../types';

export const LinesPriceInput = (props: Omit<NumberInputProps, 'children'>) => {
  const iterator = useSimpleFormIteratorItem();
  const { setValue } = useFormContext();
  // const [location] = useAppLocationState();
  const location = useLocation();


  const itemId = useWatch<Item>({ name: `lines.${iterator.index}.item` });
  const currentPrice = useWatch({ name: `lines.${iterator.index}.price` });
  const previousItemId = useRef<string>(itemId);
  const { data } = useGetMany<Item>(
    'items',
    {
      ids: [itemId],
    },
    { enabled: !!itemId }
  );
  const price = data?.[0]?.UnitPrice;

  useEffect(() => {
    // Set price when item changes OR when we have a new item but no price set
    if (previousItemId.current !== itemId || (price && !currentPrice)) {
      setValue(`lines.${iterator.index}.price`, price);
      previousItemId.current = itemId;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, previousItemId, data, price, currentPrice]);
  return <QuickbooksPriceInput {...props} />;
};
